import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { AbweichenderKontoInhaberApi } from './PersonAbweichenderKontoInhaberApi';

/**
 * APIL Url: ADAC.Internet.Types.Person.Bankverbindung
 * 
 * Endpoints: /api/Identity, /api/versicherungen/us/pruefen
 */
export class BankverbindungApi extends BaseApiModel {
	constructor(initialProperties?: Partial<BankverbindungApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected iban: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Iban(): string {
		return this.iban;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Iban(value: string) {
		this.iban = value;
	}

	protected bic: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Bic(): string {
		return this.bic;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Bic(value: string) {
		this.bic = value;
	}

	protected mandateReference: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get MandateReference(): string {
		return this.mandateReference;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set MandateReference(value: string) {
		this.mandateReference = value;
	}

	protected bankEinzugMitglied: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get BankEinzugMitglied(): boolean {
		return this.bankEinzugMitglied;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set BankEinzugMitglied(value: boolean) {
		this.bankEinzugMitglied = value;
	}

	protected bankEinzugSchutzbrief: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get BankEinzugSchutzbrief(): boolean {
		return this.bankEinzugSchutzbrief;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set BankEinzugSchutzbrief(value: boolean) {
		this.bankEinzugSchutzbrief = value;
	}

	protected abwKontoInhaber: AbweichenderKontoInhaberApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.AbweichenderKontoInhaber
	 */
	get AbwKontoInhaber(): AbweichenderKontoInhaberApi {
		return this.abwKontoInhaber;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.AbweichenderKontoInhaber
	 */
	set AbwKontoInhaber(value: AbweichenderKontoInhaberApi) {
		this.abwKontoInhaber = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): BankverbindungApi {
		return AppUtils.Helper.createFromMap(dataObject, BankverbindungApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'abwkontoinhaber':
					return AbweichenderKontoInhaberApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Iban = this.iban;
		result.Bic = this.bic;
		result.MandateReference = this.mandateReference;
		result.BankEinzugMitglied = this.bankEinzugMitglied;
		result.BankEinzugSchutzbrief = this.bankEinzugSchutzbrief;
		if (this.abwKontoInhaber) {
			result.AbwKontoInhaber = this.abwKontoInhaber.toRequestObject();
		}
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}